import React, { FunctionComponent } from 'react';
import { Loader } from 'semantic-ui-react';

const MapLoading: FunctionComponent = () => {
  return (
    <div
      style={{
        marginTop: '25px',
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%)',
        zIndex: 9999,
        backgroundColor: '#fff',
        animation: 'fadein 1s',
        borderRadius: '10px',
        border: '2px solid rgba(0, 0, 0, 0.2)',
        minWidth: '125px',
        minHeight: '70px',
        textAlign: 'center',
        paddingTop: '8px',
        fontSize: '15px',
      }}
    >
      <Loader active inline="centered" />
      Chargement...
    </div>
  );
};

export default MapLoading;
